<template>
  <div>
    <slot/>
  </div>
</template>
<script>
  import { videoLazyObserver } from '../../../../../Foundation/Core/code/Scripts/utilities/intersectionViewportObserver';

  export default {
    name: 'video-lazy',
    mounted() {
      const videoElementList = document.querySelectorAll('.video-lazy-bg-load');
      if (videoElementList.length > 0) {
        videoLazyObserver(videoElementList, 'video-lazy');
      }
    }
  };
</script>
